import { useQuery } from '@apollo/client';
import { GET_ORDER_CLOSE_CHANNEL_IDS, OrderCloseChannelIdsResponse } from '../graphql/queries/getOrderCloseChannelIds';
import { useMemo } from 'react';

/**
 * 获取关单工具支持的渠道ID列表
 * 从后端接口动态获取，适配不同环境的配置
 */
export const useOrderCloseChannelIds = () => {
    const { data, loading, error } = useQuery<OrderCloseChannelIdsResponse>(GET_ORDER_CLOSE_CHANNEL_IDS, {
        fetchPolicy: 'cache-first', // 使用缓存优先策略，减少重复请求
    });

    const channelIds = useMemo(() => {
        if (!data?.getOrderCloseChannelIds) {
            return {
                temuChannelIds: [],
                tiktokChannelIds: [],
                allChannelIds: []
            };
        }

        const { temuSmm, temuFmm, tiktokCbt, tiktokFbt, tiktokGs, exportEasy } = data.getOrderCloseChannelIds;

        // GraphQL 的 Long 类型在 JSON 中会被序列化为字符串，需要转换为数字
        const toValidId = (v: unknown): number | null => {
            const n = Number(v);
            return Number.isNaN(n) ? null : n;
        };
        const temuChannelIds = [toValidId(temuSmm), toValidId(temuFmm)].filter((id): id is number => id != null);
        const tiktokBaseIds = [toValidId(tiktokCbt), toValidId(tiktokFbt), toValidId(tiktokGs)].filter((id): id is number => id != null);
        const exportEasyId = toValidId(exportEasy);
        const tiktokChannelIds = exportEasyId != null ? [...tiktokBaseIds, exportEasyId] : tiktokBaseIds;
        const allChannelIds = [...temuChannelIds, ...tiktokChannelIds];

        return {
            temuChannelIds,
            tiktokChannelIds,
            allChannelIds
        };
    }, [data]);

    return {
        ...channelIds,
        loading,
        error
    };
};

/**
 * 获取所有关单工具支持的渠道ID列表（兼容旧接口）
 */
export const getAllOrderCloseChannelIds = (channelIds?: {
    temuSmm: number;
    temuFmm: number;
    tiktokCbt: number;
    tiktokFbt: number;
    tiktokGs: number;
    exportEasy: number;
}): number[] => {
    if (!channelIds) {
        return [];
    }
    return [
        channelIds.temuSmm,
        channelIds.temuFmm,
        channelIds.tiktokCbt,
        channelIds.tiktokFbt,
        channelIds.tiktokGs,
        channelIds.exportEasy
    ];
};
